import React from "react";

export enum ErrorContextKey {
  InvoiceForm = "InvoiceForm",
  PayableForm = "PayableForm",
  UpdateSeriesInvoice = "UpdateSeriesInvoice",
  CreateClient = "CreateClient",
  UpdateClient = "UpdateClient",
  CreateCollaborator = "CreateCollaborator",
  UpdateCollaborator = "UpdateCollaborator",
  EditContact = "EditContact",
  PaymentsSetup = "PaymentsSetup",
  BenefitsAddZipCode = "BenefitsAddZipCode",
  ActivateBenefit = "ActivateBenefit",
  BenefitsSetUp = "BenefitsSetUp",
  SignUp = "SignUp",
  SignIn = "SignIn",
  PasswordReset = "PasswordReset",
  ClientAuth = "ClientAuth",
  CreateInvoiceWithPPL = "CreateInvoiceWithPPL",
  PayInvoiceCreditCard = "PayInvoiceCreditCard",
  PayInvoiceACH = "PayInvoiceACH",
  PayInvoiceManual = "PayInvoiceManual",
  PaymentMethodRequired = "PaymentMethodRequired",
  UploadFile = "UploadFile",
  UploadLogo = "UploadLogo",
  CreatePPL = "CreatePPL",
  VerifyPhone = "VerifyPhone",
  VerifyEmail = "VerifyEmail",
  Unauthorized = "Unauthorized",
  CreateOtpSession = "CreateOtpSession",
  CreateAccount = "CreateAccount",
  AddPaymentMethod = "AddPaymentMethod",
  DisputeInvoice = "DisputeInvoice",
  IntegrationsQuickbooksMapping = "IntegrationsQuickbooksMapping",
  PendingWithholding = "PendingWithholding",
  InstantDepositAccount = "InstantDepositAccount",
  EditCollaboratorIntegrations = "EditCollaboratorIntegrations",
  EditClientIntegrations = "EditClientIntegrations",
  RevealCardDataOPT = "RevealCardDataOPT",
  CardActions = "CardActions",
  CreateCollaboratorsGroup = "CreateCollaboratorsGroup",
  UpdateCollaboratorsGroup = "UpdateCollaboratorsGroup",
  DeleteCollaboratorsGroup = "DeleteCollaboratorsGroup",
  Other = "Other",
  PayoutSettings = "PayoutSettings",
  PayrollSettings = "PayrollSettings",
  EditTemplate = "EditTemplate",
  RemoveEligibilityRequirement = "RemoveEligibilityRequirement",
  BrowsingFiles = "BrowsingFiles",
  DownloadFile = "DownloadFile",
  SettingMemberLogo = "SettingMemberLogo",
  PaymentsVerificationUpgrade = "PaymentsVerificationUpgrade",
  NEC1099Onboarding = "NEC1099Onboarding",
  BulkPayableBatchCreate = "BulkPayableBatchCreate",
  AddDebitCard = "AddDebitCard",
  NEC1099DetailsUpdate = "NEC1099DetailsUpdate"
}

export type PlatformErrorsMapping = {
  [key in ErrorContextKey]: {
    wsErrors: {
      [key: string]:
        | React.ReactNode
        | {
            [key: string]: React.ReactNode;
          };
    };
    errorRegexs?: {
      pattern: string;
      message: React.ReactNode;
    }[];
  };
};
